import React, { useState } from 'react';
import { XIcon, ShieldCheckIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  'aria-label'?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}
export function CTAButton({
  children,
  className = '',
  href = '#oferta',
  target,
  rel,
  'aria-label': ariaLabel,
  onClick
}: CTAButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Si el enlace empieza con http, es un enlace directo al carrito (ej. en OfferSection)
  const isExternal = href.startsWith('http');
  const baseClasses = `
    bg-gradient-to-r from-amber-600 to-amber-700 
    text-white rounded-full 
    px-8 py-5 md:px-12 md:py-6 
    text-[18px] md:text-[22px] font-bold 
    hover:scale-105 hover:shadow-xl 
    transition-all duration-300 ease-in-out
    shadow-lg 
    focus:ring-4 focus:ring-amber-300 focus:outline-none
    w-full sm:w-auto text-center
    inline-block
    ${className}
  `;
  if (isExternal) {
    return <a href={href} target={target} rel={rel} aria-label={ariaLabel} onClick={onClick as any} className={baseClasses} data-id="element-220">
        {children}
      </a>;
  }
  return <>
      <button type="button" aria-label={ariaLabel} onClick={e => {
      if (onClick) onClick(e);
      setIsModalOpen(true);
    }} className={baseClasses} data-id="element-221">
        {children}
      </button>

      {/* Pop-up Modal de Precio */}
      {isModalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-222">
          {/* Overlay oscuro */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => setIsModalOpen(false)} data-id="element-223" />

          {/* Contenedor del Modal */}
          <div className="bg-white rounded-3xl p-6 sm:p-10 max-w-lg w-full relative shadow-2xl border-2 border-[#B8A068] animate-in fade-in zoom-in duration-300" data-id="element-224">
            <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors bg-gray-100 hover:bg-gray-200 rounded-full p-2" aria-label="Cerrar" data-id="element-225">
              <XIcon className="w-5 h-5" data-id="element-226" />
            </button>

            <div className="text-center mt-4" data-id="element-227">
              <h3 className="font-playfair text-2xl sm:text-3xl font-bold text-[#3D2E1F] mb-4" data-id="element-228">
                Empieza tu transformación hoy
              </h3>

              <div className="mb-8" data-id="element-229">
                <span className="inline-block bg-red-600 text-white font-bold text-xs sm:text-sm uppercase tracking-widest px-3 py-1 rounded-full mb-3" data-id="element-230">
                  68% OFF
                </span>
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-231">
                  <span className="text-[#3D2E1F] opacity-50 line-through text-xl sm:text-2xl font-playfair" data-id="element-232">
                    $19.99 USD
                  </span>
                </div>
                <span className="font-playfair text-5xl sm:text-6xl font-bold text-[#B8A068]" data-id="element-233">
                  $6.39 USD
                </span>
              </div>

              <div className="flex flex-col items-center justify-center gap-4" data-id="element-234">
                <a href="https://www.fluiresvivir.com/cart/43661204652097:1" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-amber-600 to-amber-700 text-white rounded-full px-8 py-4 text-[18px] font-bold hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out shadow-lg w-full text-center block" data-id="element-235">
                  ¡QUIERO DESPERTAR SIN DOLOR AHORA!
                </a>

                <div className="flex items-center justify-center gap-2 text-[#3D2E1F] opacity-80 text-xs sm:text-sm mt-2" data-id="element-236">
                  <ShieldCheckIcon className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-237" />
                  <span data-id="element-238">Acceso inmediato. Compra 100% segura.</span>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </>;
}